(function () {
  'use strict';

  function formatFeeLabel(amount) {
    var fee = parseInt(amount, 10);
    if (isNaN(fee) || fee <= 0) return 'Free for you!';
    return '₹' + fee + ' for you!';
  }

  function formatBadgeLabel(amount) {
    var fee = parseInt(amount, 10);
    if (isNaN(fee) || fee <= 0) return 'Free';
    return '₹' + fee;
  }

  function formatFreePromoLabel(displayMode) {
    return displayMode === 'badge' ? 'Free' : 'Free for you!';
  }

  function getExcludedProductIdsFromNote(note) {
    var ids = [];
    if (!note) return ids;

    var raw = note.getAttribute('data-excluded-product-ids');
    if (raw) {
      raw.split(',').forEach(function (part) {
        var id = String(part || '').trim();
        if (id) ids.push(id);
      });
    }

    var jsonRaw = note.getAttribute('data-excluded-products-json');
    if (jsonRaw) {
      try {
        var parsed = JSON.parse(jsonRaw);
        if (Array.isArray(parsed)) {
          parsed.forEach(function (entry) {
            var id = entry && typeof entry === 'object' ? entry.id : entry;
            if (id != null && String(id).trim() !== '') ids.push(String(id));
          });
        }
      } catch (error) {
        /* ignore malformed JSON */
      }
    }

    return ids;
  }

  function isProductPersonalizationFree(productId, note) {
    if (!productId) return false;

    var id = String(productId);

    if (window.personalizationFeeConfig && Array.isArray(window.personalizationFeeConfig.excludedProducts)) {
      var excluded = window.personalizationFeeConfig.excludedProducts;
      for (var i = 0; i < excluded.length; i++) {
        var entry = excluded[i];
        var entryId = entry && typeof entry === 'object' ? entry.id : entry;
        if (String(entryId) === id) return true;
      }
    }

    var noteIds = getExcludedProductIdsFromNote(note);
    for (var j = 0; j < noteIds.length; j++) {
      if (noteIds[j] === id) return true;
    }

    return false;
  }

  function updateNoteElement(note) {
    if (!note) return Promise.resolve();

    var enabled = note.getAttribute('data-fee-enabled') !== 'false';
    var feeAmount = parseInt(note.getAttribute('data-fee-amount'), 10) || 0;
    var freeRules = note.getAttribute('data-free-rules-enabled') === 'true';
    var freeAbove = parseInt(note.getAttribute('data-free-above'), 10) || 0;
    var displayMode = note.getAttribute('data-fee-display') || 'note';
    var productId = note.getAttribute('data-product-id');
    var label = note.querySelector('[data-personalization-fee-label]');
    var compareEl = note.querySelector('[data-personalization-fee-compare]');

    if (!label) return Promise.resolve();

    function applyLabel(text) {
      label.textContent = text;
    }

    if (compareEl) {
      var compareAmount = parseInt(note.getAttribute('data-compare-amount'), 10) || 0;
      compareEl.textContent = compareAmount > 0 ? '₹' + compareAmount : '';
    }

    if (isProductPersonalizationFree(productId, note)) {
      applyLabel(formatFreePromoLabel(displayMode));
      return Promise.resolve();
    }

    if (!enabled || feeAmount <= 0) {
      applyLabel(formatFreePromoLabel(displayMode));
      return Promise.resolve();
    }

    if (!freeRules || freeAbove <= 0) {
      applyLabel(displayMode === 'badge' ? formatBadgeLabel(feeAmount) : formatFeeLabel(feeAmount));
      return Promise.resolve();
    }

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        var isFree = total >= freeAbove;

        if (displayMode === 'badge') {
          applyLabel(isFree ? 'Free' : formatBadgeLabel(feeAmount));
        } else {
          applyLabel(isFree ? 'Free for you!' : formatFeeLabel(feeAmount));
        }
      })
      .catch(function () {
        applyLabel(displayMode === 'badge' ? formatBadgeLabel(feeAmount) : formatFeeLabel(feeAmount));
      });
  }

  function syncProductId(note, productId) {
    if (!note) return;
    if (productId == null || productId === '') {
      note.removeAttribute('data-product-id');
    } else {
      note.setAttribute('data-product-id', String(productId));
    }
  }

  function updateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var notes = scope.querySelectorAll('[data-personalization-fee-note]');

    if (!notes.length) return Promise.resolve();

    return Promise.all(Array.prototype.map.call(notes, updateNoteElement));
  }

  window.RabitatPersonalizationFee = {
    updateAll: updateAll,
    updateNote: updateNoteElement,
    syncProductId: syncProductId,
    isProductPersonalizationFree: isProductPersonalizationFree
  };
})();
